import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import VerifyRequestPage from './VerifyRequestPage';

// ============================================================================
// VERIFY REQUEST PAGE WRAPPER - GET ALL PARAMS
// ============================================================================

interface VerifyRequestPageWrapperProps extends WithTranslation {
  // Props will be passed through to VerifyRequestPage
}

const VerifyRequestPageWrapper: React.FC<VerifyRequestPageWrapperProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract all navigation parameters from URL query string (match reference navigation.getParam)
  const searchParams = new URLSearchParams(location.search);
  const state = location.state as any;
  
  // All required parameters for VerifyRequestPage (match reference implementation)
  const leave_id = searchParams.get('leave_id') || state?.leave_id || '';
  const categoryId = searchParams.get('categoryId') || state?.categoryId || '';
  const childId = searchParams.get('childId') || state?.childId || '';
  const checkLeave = searchParams.get('checkLeave') || state?.checkLeave || '';
  
  // Navigation functions (match reference navigation object)
  const handleNavigate = (path: string, params?: any) => {
    if (params) {
      // Convert params to query string for better web parameter management
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const queryString = queryParams.toString();
      navigate(queryString ? `${path}?${queryString}` : path);
    } else {
      navigate(path);
    }
  };
  
  const handleGoBack = () => {
    navigate(-1);
  };
  
  // Debug logging for development
  if (process.env.NODE_ENV === 'development') {
    console.log('VerifyRequestPageWrapper - All params:', {
      leave_id,
      categoryId,
      childId,
      checkLeave,
      locationState: state,
      searchParams: Object.fromEntries(searchParams.entries()),
      fullLocation: location
    });
  }
  
  return (
    <VerifyRequestPage
      {...props}
      // Pass all navigation parameters as props (match reference)
      leave_id={leave_id}
      categoryId={categoryId}
      childId={childId}
      checkLeave={checkLeave}
      location={location}
      navigate={handleNavigate}
      goBack={handleGoBack}
    />
  );
};

export default withTranslation()(VerifyRequestPageWrapper);
